/* eslint-disable max-len */
import PropTypes from 'prop-types';
import ShopBlocks, { SHOP_BLOCKS } from '@outdoor-voices/ui/dist/components/ShopBlocks';
import React from 'react';
import DoingThings from '../icons/DoingThings';
import Footer from '../Footer';
import css from './SubmitAReview.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Submitted = function Submitted(_ref) {
  var name = _ref.name,
      productName = _ref.productName;
  var nameString = name && name.length ? ", ".concat(name) : '';
  var thanksString = "Thanks for your help".concat(nameString, "!");
  var productString = "Your review for ".concat(productName, " was submitted. Once your review is verified, you'll earn OV Rewards points.");
  SHOP_BLOCKS[0].cta.href = '/collections/bestsellers?genderFilter=woman';
  SHOP_BLOCKS[0].image.right = true;
  SHOP_BLOCKS[1].cta.href = '/collections/bestsellers?genderFilter=man';
  SHOP_BLOCKS[1].image.left = true;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.submitted,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.thanksTitle,
        children: thanksString
      }), /*#__PURE__*/_jsx("div", {
        className: css.subTitle,
        children: productString
      }), /*#__PURE__*/_jsx(DoingThings, {
        className: css.svg
      }), /*#__PURE__*/_jsx(ShopBlocks, {
        blocks: SHOP_BLOCKS
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: css.footer,
      children: /*#__PURE__*/_jsx(Footer, {})
    })]
  });
};

Submitted.defaultProps = {
  name: '',
  productName: ''
};
Submitted.propTypes = {
  name: PropTypes.string,
  productName: PropTypes.string.isRequired
};
export default Submitted;